import { Controller as BaseController } from "@hotwired/stimulus"

export class Controller extends BaseController {
  static targets = ["input", "results"]
  static values = {
    url: String,
    queryParam: { type: String, default: "q" },
    minLength: { type: Number, default: 2 },
    trigger: { type: String, default: "input" }
  }

  get inputElement() {
    if (this.hasInputTarget) return this.inputTarget
    return this.element.querySelector("input, textarea")
  }

  connect() {
    this.boundOnInput = this.onInput.bind(this)
    this.boundOnBlur = this.onBlur.bind(this)
    this.boundOnResultsClick = this.onResultsClick.bind(this)

    const input = this.inputElement
    if (!input) return

    input.addEventListener("input", this.boundOnInput)
    input.addEventListener("blur", this.boundOnBlur)
    this.resultsTarget.addEventListener("click", this.boundOnResultsClick)
  }

  disconnect() {
    const input = this.inputElement
    if (input) {
      input.removeEventListener("input", this.boundOnInput)
      input.removeEventListener("blur", this.boundOnBlur)
    }
    this.resultsTarget.removeEventListener("click", this.boundOnResultsClick)
    clearTimeout(this.debounceTimeout)
  }

  onInput() {
    if (this.triggerValue === "blur") {
      this.resultsTarget.innerHTML = ""
      return
    }

    clearTimeout(this.debounceTimeout)
    this.debounceTimeout = setTimeout(() => {
      this.fetchSuggestions()
    }, 300)
  }

  onBlur() {
    if (this.triggerValue === "blur") {
      this.fetchSuggestions()
    }
  }

  onResultsClick(event) {
    const target = event.target.closest("[data-value]")
    if (!target) return

    const value = target.dataset.value
    if (value) {
      const input = this.inputElement
      if (input) input.value = value
      this.resultsTarget.innerHTML = ""
    }
  }

  fetchSuggestions() {
    const input = this.inputElement
    if (!input) return

    const query = input.value.trim()

    if (query.length < this.minLengthValue) {
      this.resultsTarget.innerHTML = ""
      return
    }

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set(this.queryParamValue, query)

    fetch(url.toString(), {
      headers: { Accept: "text/vnd.turbo-stream.html, text/html" }
    })
      .then(response => response.text())
      .then(html => {
        this.resultsTarget.innerHTML = html
      })
      .catch(() => {
        this.resultsTarget.innerHTML = ""
      })
  }
}
